<template>
  <div class="echarts">
    <div class="filter-row">
      <RadioGroup v-model="timeType" type="button" @on-change="timeTypeChange">
        <Radio label="本周"></Radio>
        <Radio label="上周"></Radio>
        <Radio label="本月"></Radio>
        <Radio label="上月"></Radio>
        <Radio label="本季度"></Radio>
        <Radio label="上季度"></Radio>
      </RadioGroup>
    </div>
    <Alert show-icon>
        {{timeType}}
        <Icon type="social-yen" slot="icon"></Icon>
        <template slot="desc">总申报费用：{{priceCount}} 元</template>
    </Alert>
    <!-- <IEcharts
      :option="bar"
      :loading="loading"
      @ready="onReady"
      @click="onClick"
    /> -->
  </div>
</template>

<script>
  import { fetch } from '../fetch/api'
  // import IEcharts from 'vue-echarts-v3/src/lite.js'
  // import 'echarts/lib/chart/line'
  // import 'echarts/lib/chart/bar'
  // import 'echarts/lib/chart/pie'
  // import 'echarts/lib/chart/scatter'
  // import 'echarts/lib/chart/radar'

  // import 'echarts/lib/chart/map'
  // import 'echarts/lib/chart/treemap'
  // import 'echarts/lib/chart/graph'
  // import 'echarts/lib/chart/gauge'
  // import 'echarts/lib/chart/funnel'
  // import 'echarts/lib/chart/parallel'
  // import 'echarts/lib/chart/sankey'
  // import 'echarts/lib/chart/boxplot'
  // import 'echarts/lib/chart/candlestick'
  // import 'echarts/lib/chart/effectScatter'
  // import 'echarts/lib/chart/lines'
  // import 'echarts/lib/chart/heatmap'

  // import 'echarts/lib/component/graphic'
  // import 'echarts/lib/component/grid'
  // import 'echarts/lib/component/legend'
  // import 'echarts/lib/component/tooltip'
  // import 'echarts/lib/component/polar'
  // import 'echarts/lib/component/geo'
  // import 'echarts/lib/component/parallel'
  // import 'echarts/lib/component/singleAxis'
  // import 'echarts/lib/component/brush'

  // import 'echarts/lib/component/title'

  // import 'echarts/lib/component/dataZoom'
  // import 'echarts/lib/component/visualMap'

  // import 'echarts/lib/component/markPoint'
  // import 'echarts/lib/component/markLine'
  // import 'echarts/lib/component/markArea'

  // import 'echarts/lib/component/timeline'
  // import 'echarts/lib/component/toolbox'

  // import 'zrender/lib/vml/vml'
  export default {
    name: 'CostsCount',
    components: {
      // IEcharts
    },
    props: {
    },
    data () {
      return {
        timeType: '本周',
        priceCount: 0,
        loading: true,
        bar: {
          title: {
            text: ''
          },
          tooltip: {},
          xAxis: {
            data: ['房租及中介费', '住宿费', '交通费', '通讯费', '测试费', '车辆租赁费', '车辆使用费', '办公费', '生活用品费', '过路过桥费', '设备购置费', '设备租赁费', '零星材料费', '团队建设费', '燃油费', '搬运费', '其他费用'],
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          },
          yAxis: {},
          series: [{
            name: '申报汇总',
            type: 'bar',
            data: []
          }]
        }
      }
    },
    watch: {
      timeType () {
        this.fetchBarData()
      }
    },
    mounted () {
      this.fetchBarData()
    },
    methods: {
      timeTypeChange (val) {
        this.timeType = val
      },
      fetchBarData () {
        let params = {
          time: this.timeType
        }
        this.loading = true
        this.priceCount = 0
        fetch(`costs/count`, {params: params}).then(res => {
          this.bar.series[0].data = res
          for (let k in res) {
            this.priceCount = this.priceCount + Number(res[k])
          }
          this.loading = false
        })
      },
      onReady () {
        this.loading = false
        // console.log('ready')
      },
      onClick () {
        this.loading = true
        // console.log('arguments')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .echarts {
    width: 100%;
    height: 400px;
  }
</style>
